// extracted by mini-css-extract-plugin
export var input = "SearchBar-module--input--WiLeq";
export var root = "SearchBar-module--root--mxZ3a";
export var searchBar = "SearchBar-module--searchBar--YmRML";
export var submit = "SearchBar-module--submit--tvao8";